<template>
    <div id="addressWrapper" :class="$x['address-wrapper']" data-app>
        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
        <section v-if="!showAddNewAddress && !showEditAddress">
            <ns-alert
                v-for="a in alerts" :key="a.id"
                :class="$x['alert-address']"
                type="card"
                :context="a.context"
                :title="a.title"
                visible
            >
                <template #body><span v-html="a.message"></span></template>
            </ns-alert>
            <div :class="$x['saved-addresses-header']">
                <h2 :class="$x['saved-address-title']">
                    <span>{{t.savedAddresses}}</span>
                </h2>
                <h3
                    :class="$x['add-address']"
                    @click="openAddressForm(null)"
                    data-testid="openAddressForm"
                >
                    <ns-icon icon-name="icon-add" size="icon-lg" /> {{t.add}}
                </h3>
            </div>
            <div v-if="addressList && addressList.length === 0">No Saved Addresses</div>
            <div :class="$x['saved-address']" v-for="a in addressList" :key="a.beShippingAddressId">
                <div>
                    <div v-show="!shippingAddressFormat">
                        <h3 :class="$x['address-name']">{{a.addressName}}</h3>
                        <div>{{a.address1}}</div>
                        <div v-show="a.address2">{{a.address2}}</div>
                        <div v-show="a.county">{{a.county}}</div>
                        <div v-show="a.addressType!=='7-11'">
                            {{a.city}},
                            <span v-show="a.district">{{a.district}}, </span>
                            <span v-html="getRegionName(a.region)"></span>
                            <span v-show="!hideShippingPostalCode">{{a.postalCode}}</span>
                        </div>
                        <div class="shippingCountry" v-show="a.country">
                            {{a.country}}
                        </div>
                        <div>{{a.mobilePhone || a.phone}}</div>
                        <div v-show="a.email && formFields[country] && formFields[country].email && formFields[country].email.show">{{a.email}}</div>
                        <div v-show="a.instructions && formFields[country] && formFields[country].instructions && formFields[country].instructions.show">{{a.instructions}}
                        </div>
                        <div
                            v-if="a.defaultShipping"
                            :class="$x['add-default']"
                            name="defaultAdd"
                        >
                            <ns-icon
                                icon-name="icon-checkmark"
                                style="width: 20px; height: 20px; display: inline-block; margin-right: 5px"
                            />
                        <span>{{ checkoutStrings.defaultAddressText }}</span>
                        </div>
                    </div>
                    <div v-show="shippingAddressFormat">
                        <li :class="$x['address-name']">{{a.addressName}}</li>
                        <li v-show="a.postalCode">{{a.postalCode}} <span v-html="getRegionName(a.region)"></span></li>
                        <li v-show="a.city">{{a.city}}</li>
                        <li v-show="a.district">{{a.district}}</li>
                        <li v-show="a.address1">{{a.address1}}</li>
                        <li v-show="a.address2">{{a.address2}}</li>
                        <li v-show="a.mobilePhone || a.phone">{{a.mobilePhone || a.phone}}</li>
                        <li class="shippingEmail" v-show="a.email && formFields[country] && formFields[country].email && formFields[country].email.show">
                            {{a.email}}
                        </li>
                        <li class="shippingInstructions" v-show="a.instructions && formFields[country] && formFields[country].instructions && formFields[country].instructions.show">
                            {{a.instructions}}
                        </li>
                        <div
                            v-if="a.defaultShipping"
                            :class="$x['add-default']"
                            name="defaultAdd"
                        >
                            <ns-icon
                                icon-name="icon-checkmark"
                                style="width: 20px; height: 20px; display: inline-block; margin-right: 5px"
                            />
                        <span>{{ checkoutStrings.defaultAddressText }}</span>
                        </div>
                    </div>
                </div>
                <div :class="$x['address-selector-menu']">
                    <v-menu attach left light content-class="pop-menu">
                        <template v-slot:activator="{ on }">
                        <!-- It seems that the activator clicks are not captured by the payment-wrapper @click event
                            so we update the totalClicks here when the menu is clicked-->
                        <button
                            :class="$x['action-button']"
                            name="editMenu"
                            v-on="on"
                            @click="totalClicks++"
                        >
                            <ns-icon icon-name="icon-menu-dots" />
                        </button>
                        </template>
                        <v-list>
                        <v-list-tile @click="openAddressForm(a)" name="editPayment">
                            <v-list-tile-avatar>
                            <ns-icon icon-name="icon-edit" />
                            </v-list-tile-avatar>
                            <v-list-tile-title>{{checkoutStrings.editText}}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                            v-show="canDelete"
                            @click="openDeleteConfirmation(a.id)"
                            name="deletePayment"
                        >
                            <v-list-tile-avatar>
                            <ns-icon icon-name="icon-trashcan" />
                            </v-list-tile-avatar>
                            <v-list-tile-title>{{t.delete}}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                            @click="doUpdateDefaultAddress(a)"
                            name="updateDefault"
                        >
                            <v-list-tile-avatar>
                            <ns-icon icon-name="icon-checkmark" />
                            </v-list-tile-avatar>
                            <v-list-tile-title>{{t.setDefault}}</v-list-tile-title>
                        </v-list-tile>
                        </v-list>
                    </v-menu>
                </div>
            </div>
        </section>
        <section v-if="showAddNewAddress">
            <ns-alert
                v-for="a in alerts" :key="a.id"
                :class="$x['alert-address']"
                type="card"
                :context="a.context"
                :title="a.title"
                visible
            >
                <template #body><span v-html="a.message"></span></template>
            </ns-alert>
            <div id="addAddressSection" :class="$x.contents">
                <div>
                    <ns-shipping-address-form
                        v-model="formData"
                        ref="addAddressForm"
                        :t="t"
                        :disable-address-name="disableAddressName"
                        :language="language"
                        :country="formCountry"
                    ></ns-shipping-address-form>
                </div>
                <div :class="$x['border-top']">
                    <v-checkbox
                        v-if="!isGuest"
                        v-model="agreeToSave"
                        disabled
                        color="#7123D9"
                    >
                    <template slot="label">
                        {{ t.agreeToSaveAddress }}
                    </template>
                    </v-checkbox>
                    <v-checkbox v-if="!isGuest" v-model="setAsDefault" :disabled="!agreeToSave" color="#7123D9">
                        <template slot="label">{{ t.setAsDefault }}</template>
                    </v-checkbox>
                    <button
                        v-if="editingAddress && canDelete"
                        class="alert-ghost"
                        type="button"
                        @click="openDeleteConfirmation(formData.id)"
                        name="openDeleteConfirmation"
                    >
                    <ns-icon icon-name="icon-trashcan" />{{ t.deleteAddress }}
                    </button>
                </div>
                <div :class="[$x.addressButtons, $x['border-top']]">
                    <button
                        class="hit-solid fluid form-save"
                        name="saveAddress"
                        @click="validateAndSave(formData)"
                        data-testid="validateAndSave"
                    >
                    {{ t.saveAddress }}
                    </button>
                    <button
                        class="hit-outline fluid"
                        name="cancelSaveAddress"
                        @click="cleanupAddEditAddress"
                    >
                    {{ t.cancel }}
                    </button>
                </div>
            </div>
        </section>
        <v-dialog v-model="deleteConfirm" content-class="delete-confirmation">
            <v-card>
                <v-card-title class="title-small-bold">{{ t.deleteAddress }}</v-card-title>
                <v-card-actions>
                    <button
                        class="inverse-solid short"
                        @click="deleteConfirm = false"
                        name="cancelDelete"
                    >
                    {{ t.cancel }}
                    </button>
                    <button
                        class="alert-solid short"
                        @click="doDeleteAddress()"
                        name="confirmDelete"
                    >
                    {{ t.delete }}
                    </button>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showGav" content-class="gav-modal" persistent>
            <v-card>
                <gav
                    ref="gav"
                    :locale-country="country"
                    :locale-language="language"
                    :input-address="inputAddress"
                    callingModule="defaultCallingModule"
                    @confirm-address="gavConfirmAddress"
                    @toggle-gav="cancelGavPopup"
                />
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { VList, VListTile, VListTileTitle, VListTileAvatar, VCheckbox, VMenu, VDialog, VCard, VCardTitle, VCardActions } from "vuetify/lib";
import { NsIcon, NsAlert } from "@nuskin/design-components";
import { Gav } from "@nuskin/smart-common-components";
import NsShippingAddressForm from './NsShippingAddressForm.vue';
import ADDRESS_MIXIN from "./addressMixin";
import GAV_MIXIN from "../mixins/gavMixin";

const COMPLETE_STATE = "complete";
const LIST_ADDRESS_STATE = "list-addresses";
const ADD_ADDRESS_STATE = "add-address";

const STATE = "state";
const EDIT = "edit";
const COMPLETE = "complete";
const BUSY = "busy";
const NOT_BUSY = "not-busy";

export default {
    name: "NsAddressManager",
    components: {
        VList,
        VListTile,
        VListTileTitle,
        VListTileAvatar,
        VCheckbox,
        VMenu,
        VDialog,
        VCard,
        VCardTitle,
        VCardActions,
        NsAlert,
        NsShippingAddressForm,
        NsIcon,
        Gav
    },
    mixins: [ADDRESS_MIXIN, GAV_MIXIN],
    data() {
        return {
            addressList: null,
            currentEditedAddress: null,
            deleteAddressId: null,
            deleteConfirm: false,
            gavAddress: {},
            isBusy: false,
            saveAddressProcessing: false,
            selectedAddress: null,
            selectedAddressId: null,
            selectedAddressString: "",
            showAddNewAddress: false,
            showEditAddress: false,
            showSavedAddresses: false
        };
    },
    watch: {
        agreeToSave() {
            this.setAsDefault = !this.agreeToSave ? false : this.setAsDefault;
        },
        showGav() {
            if (!this.showGav) {
                this.$emit(STATE, this.isBusy ? BUSY : NOT_BUSY);
            } else  {
                this.$emit(STATE, NOT_BUSY);
            }
        },
        isBusy() {
            if (this.isBusy === true) {
                this.$emit(STATE, !this.showGav ? BUSY : NOT_BUSY);
            } else {
                this.$emit(STATE, NOT_BUSY);
            }
        }
    },
    methods: {
        cancelGavPopup() {
            this.cancelGav();
            this.isBusy = false;
            const address = this.showAddNewAddress ? this.formData : this.addressList.find(a => a.id === this.selectedAddressId);
            address.verified = true;
            this.openAddressForm(address, LIST_ADDRESS_STATE);
        },

        cleanupAddEditAddress(address) {
            if (address) {
                if (address.defaultShipping) {
                    this.updateDefaultAddressOrder();
                }
            }
            // Cleanup
            if (this.afterGavView === COMPLETE_STATE) {
                this.setSelectedAddress();
            } else {
                this.showState(this.afterGavView);
            }
            this.resetForms();
            this.currentEditedAddress = {};
            this.formCountry = null;
            this.formData = {};
            this.agreeToSave = false;
            this.saveAddressProcessing = false;
        },

        clearStateFlags() {
            this.showSavedAddresses = false;
            this.showAddNewAddress = false;
            this.editingAddress = false;
            this.clearAlerts();
        },

        async doDeleteAddress() {
            this.deleteConfirm = false;
            // To call the ShippingService we need a loggedin user and the payment must be saved
            this.isBusy = true;
            const deleted = await this.deleteAddress(this.deleteAddressId/*, this.showEditPayment*/);
            this.isBusy = false;
            if (deleted) {
                if (this.editingAddress) {
                    this.cleanupAddEditAddress();
                }
            } else {
                this.addToAlerts();
            }
        },

        async doUpdateDefaultAddress(address) {
            this.isBusy = true;
            await this.updateDefaultAddress(address);
            this.selectedAddressId = address.id;
            this.isBusy = false;
        },

        async gavConfirmAddress(address) {
            const [modified, confirmedAddress] = this.handleGavConfirm(address);
            if (modified) {
                await this.saveShippingAddress(confirmedAddress);
            }
            this.cleanupAddEditAddress(confirmedAddress);
        },

        openAddressForm(address, nextView = LIST_ADDRESS_STATE) {
            this.initAddressForm(address, nextView);
        },

        openDeleteConfirmation(addressId) {
            this.deleteAddressId = addressId;
            this.deleteConfirm = true;
        },

        async saveShippingAddress(address) {
            this.isBusy = true;
            if (typeof address.id === 'number' && address.id > 0) {
                try {
                    address.defaultShipping = this.setAsDefault;
                    await this.editAddress(address/*, editMethod*/);
                } catch (err) {
                    this.addToAlerts();
                }
            } else {
                try {
                    if (typeof address.id === 'number' && address.id < 0) {
                        // Was previously created but not saved to profile. Now the
                        // user wants to save it off of an edit. Need to delete it
                        // from addressList because it will be added to the list again.
                        await this.deleteAddress(address.id/*, true*/);
                        address.id = null;
                    }
                    this.selectedAddressId = await this.addAddress(address, this.agreeToSave);
                } catch (err) {
                    this.addToAlerts();
                }
            }
            this.isBusy = false;
        },

        setSelectedAddress() {
            if (this.selectedAddressId) {
                this.selectedAddress = this.addressList.find(a => a.id === this.selectedAddressId);
                this.setState();
            }
        },

        /**
         * Sets complete state for the component and show appropriate view.
         */
        setState() {
            let switchedState = false;
            if (this.addressList.length > 0) {
                if (this.selectedAddress &&
                    (this.enableAddressValidation &&
                    this.validateShippingAddressOnLoad &&
                    !this.selectedAddress.verified)) {
                    this.emitSelectedAddress(null);
                } else if (this.selectedAddress) {
                    this.emitSelectedAddress(this.selectedAddress);
                }
                switchedState = this.showState(LIST_ADDRESS_STATE);
            } else {
                let address = null;
                this.openAddressForm(address, LIST_ADDRESS_STATE);
                this.emitSelectedAddress(null);
            }

            if (switchedState) {
                this.$emit(STATE, this.showSavedAddresses ? COMPLETE : EDIT);
            }
        },

        showState(section) {
            let switchedState = false;

            switch (section) {
                case LIST_ADDRESS_STATE:
                    if (!this.showSavedAddresses) {
                        this.clearStateFlags();
                        this.showSavedAddresses = true;
                        switchedState = true;
                    }
                break;
                case ADD_ADDRESS_STATE:
                    if (!this.showAddNewAddress) {
                        this.clearStateFlags();
                        this.showAddNewAddress = true;
                        switchedState = true;
                    }
                break;
            }

            return switchedState;
        },

        /**
         * validateAndSave
         *
         * @param address
         * @return {Promise<void>}
         */
        async validateAndSave(address) {
            if (this.$refs.addAddressForm.validate()) {
                this.saveAddressProcessing = true;
                this.isBusy = true;
                address.defaultShipping = this.setAsDefault;

                if (this.enableAddressValidation) {
                    this.openGavAndLoadSuggestions(address, true);
                } else {
                    await this.saveShippingAddress(address);
                    this.cleanupAddEditAddress(address);
                }
            }
        },
    },
    mounted() {
        // Make sure translations are loaded first
        this.initMixin().finally(()=> {
            this.getDefaultAddress().then(async selAddress => {
                if (selAddress) {
                    this.selectedAddress = selAddress;
                    if (this.enableAddressValidation &&
                        this.validateShippingAddressOnLoad &&
                        this.selectedAddress.verified !== true) {
                        this.selectedAddress.verified = false;
                        this.afterGavView = LIST_ADDRESS_STATE;
                        this.isBusy = true;
                        this.openGavAndLoadSuggestions(this.selectedAddress, true);
                    }
                    this.selectedAddressId = this.selectedAddress.id;
                    this.updateDefaultAddressOrder();
                }
                this.setState();
            });
        });
    }
}
</script>

<style lang="scss" module="$x">
@use "./addressManager.module.scss";
//TODO a temp fix for a weird issue. removing it start throwing error while unit test.
.dummy {
  color: blue;
}
</style>

<style lang="scss">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@use "~@nuskin/ns-core-styles/src/scss/gridStyles";
@use "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";

$dryink: map.get(colors.$baseColors, "dryink");
$blackhole: map.get(colors.$baseColors, "blackhole");
$eyore: map.get(colors.$baseColors, "eyore");

#addAddressSection {
  max-width: 500px;
  text-align: left;
  box-sizing: border-box;
  padding: 0;

  button.alert-ghost {
    margin-bottom: 25px;
  }
}

.gav-modal {
  text-align: left;
}

[class^="NsAddressManager_"] {
  .v-input--selection-controls {
    padding-top: 0;
    margin-top: 10px !important;
  }

  .v-menu__content.menuable__content__active.pop-menu {
    min-width: 300px !important;
    border: 3px solid $dryink !important;
    overflow: hidden;
  }

  .v-menu__content {
    z-index: 101 !important;
  }

  .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
    align-items: center;

    label {
      margin-bottom: 0;

      ul {
        padding-left: 0;
      }

      li {
        list-style: none;
      }
    }
  }

  .v-select .v-input__control .v-input__slot {
    border: none;
    padding: 0;

    .v-select__slot {
      flex-flow: column nowrap !important;

      .v-input__append-inner {
        bottom: 7px;
        right: 5px;
        top: auto;
        margin: 0;
        z-index: 100;
        position: absolute;
      }
      .v-select__selections {
        position: relative;

        .v-select__selection--comma {
          margin: 0;
          position: absolute;
          top: 50%;
          left: 20px;
          transform: translateY(-50%);
          z-index: 100;
        }

        input {
          border: 1px solid $dryink;

          &:focus {
            box-shadow: 0 0 5px 2px rgba(113, 35, 217, 0.2);
          }

          &:disabled {
              border-color: rgba(0, 0, 0, 0.38);
          }
        }
      }
      label.primary--text {
        color: $blackhole !important;
        font-size: 16px;
        font-family: "proxima-nova", sans-serif;
      }
      svg {
        color: $blackhole !important;
      }
    }
  }

  .v-label {
    font-family: map.get(typographyVariables.$typography, "font-family-primary");
  }

  .v-radio {
    justify-content: flex-start;

    .v-icon.accent--text {
      color: map.get(colors.$baseColors, "shells") !important;
    }
  }

  .v-radio--is-disabled {
    .v-label {
      color: $eyore;
    }
  }

  .v-input--radio-group {
    .v-input__control {
      width: 100%;
    }
  }

  .v-input--radio-group {
    .v-input__control {
      width: 100%;
    }
  }

  .radio-option {
    display: flex;
    justify-content: flex-start;
    cursor: pointer;

    .label {
      margin-left: -22px;
    }
  }
}

.delete-confirmation {
  .title-small-bold {
    margin-bottom: 22px;
    justify-content: center;
  }

  .v-card__actions {
    justify-content: flex-end;

    button:first-child {
      margin-right: 20px;

      &:focus {
        outline: none;
      }
    }

    .alert-solid {
      min-width: 175px;
    }

    @media screen and (max-width: gridStyles.$phone) {
      flex-flow: column-reverse;

      button {
        width: 100%;

        &:first-child {
          margin-right: 0;
        }

        &:nth-child(2) {
          margin-bottom: 10px;
        }
      }
    }
  }
}

[class*="__nsAddressForm"] {
  @import "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";
}
</style>
